// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusFilter_wrapper__34TxO"};